import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';

import { db } from "../../lib/firebaseCompat"

import { useTooltip } from "../../hooks/useTooltip";

export default function EstimateTdDownload({createdByUid}) {
  const [email, setEmail] = useState();

  useEffect(() => {
    (async () => {
      const ref = db.collection("users").doc(createdByUid);
      const doc = await ref.get()
      const data = doc.data();
      setEmail(data.email);
    })();

  }, [db, createdByUid]);

  return (
    <td>
      {email}
    </td>
  );
}

EstimateTdDownload.propTypes = {
  createdByUid: PropTypes.string.isRequired,
}
